import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado, por favor inicia sesión");
  return { Authorization: `Bearer ${token}` };
};

export const listCourierControl = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/courier-control`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getCourierControl = async (id) => {
  const response = await axios.get(`${API_URL}/api/courier-control/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const createCourierControl = async (payload) => {
  const response = await axios.post(`${API_URL}/api/courier-control`, payload, {
    headers: authHeaders(),
  });
  return response.data;
};

export const updateCourierControl = async (id, payload) => {
  const response = await axios.put(
    `${API_URL}/api/courier-control/${id}`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data;
};

export const deleteCourierControl = async (id) => {
  const response = await axios.delete(`${API_URL}/api/courier-control/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getCourierControlByMuestra = async (idMuestra) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const markCourierEntregadoForMuestra = async (idMuestra) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/entregado`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

/** ARRIVED SDS: cierra Courier o crea llegada sintética (sin SENT previo). */
export const registerLlegadaSdsForMuestra = async (idMuestra, fecha = null) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/llegada-sds`,
    fecha ? { fecha } : {},
    { headers: authHeaders() },
  );
  return response.data;
};

/** Piezas del envío vinculado (diálogo llegada en lote). */
export const getPiezasEnvioByMuestra = async (idMuestra) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/piezas-envio`,
    { headers: authHeaders() },
  );
  return response.data;
};

/**
 * Llegada en lote: todas las muestras del Courier → Arrived* + ENTREGADO.
 * Sin Courier y ARRIVED SDS → llegada sintética.
 */
export const markLlegadaLoteForMuestra = async (
  idMuestra,
  {
    ID_ESTADO = null,
    fecha = null,
    Origen = null,
    NumeroAwb = null,
    CompaniaCourier = null,
    SolicitadoPor = null,
  } = {},
) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/llegada-lote`,
    {
      ...(ID_ESTADO != null ? { ID_ESTADO } : {}),
      ...(fecha ? { fecha } : {}),
      ...(Origen ? { Origen } : {}),
      ...(NumeroAwb ? { NumeroAwb } : {}),
      ...(CompaniaCourier ? { CompaniaCourier } : {}),
      ...(SolicitadoPor ? { SolicitadoPor } : {}),
    },
    { headers: authHeaders() },
  );
  return response.data;
};

/** Sent to Client → Se queda en Cliente (reetiqueta o crea envío). */
export const markQuedaClienteForMuestra = async (idMuestra, payload = {}) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/queda-cliente`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const searchMuestrasCourier = async (q) => {
  const response = await axios.get(`${API_URL}/api/courier-control/muestras`, {
    headers: authHeaders(),
    params: { q },
  });
  return response.data;
};

export const getCourierMuestraLineaFields = async (idMuestra) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/muestras/${idMuestra}/linea-fields`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const listCourierPendientes = async () => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/pendientes`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createCourierDesdeMuestras = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/desde-muestras`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

/** Unifica N envíos sueltos en uno (mismas piezas → una sola caja). */
export const unificarCourierControl = async ({ ids, targetId } = {}) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/unificar`,
    {
      ids,
      ...(targetId != null ? { targetId } : {}),
    },
    { headers: authHeaders() },
  );
  return response.data;
};

function downloadBlobAsFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

function filenameFromContentDisposition(header, fallback) {
  const raw = String(header || "");
  const m =
    raw.match(/filename\*=UTF-8''([^;]+)/i) ||
    raw.match(/filename="([^"]+)"/i) ||
    raw.match(/filename=([^;]+)/i);
  if (!m?.[1]) return fallback;
  try {
    return decodeURIComponent(m[1].trim());
  } catch {
    return m[1].trim() || fallback;
  }
}

/** PDF informe envío (fotos + ficha por pieza). */
export const downloadCourierInformePdf = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/${id}/docs/informe`,
    {
      headers: authHeaders(),
      responseType: "blob",
    },
  );
  const filename = filenameFromContentDisposition(
    response.headers?.["content-disposition"],
    `Informe_envio_${id}.pdf`,
  );
  downloadBlobAsFile(response.data, filename);
  return filename;
};

/** PDF factura comercial aduanas (firma Borja + sello NML/SDS según shipFrom).
 * @param {number|string} id
 * @param {{ shipFrom?: "NML"|"STAGE" }} [opts]
 */
export const downloadCourierFacturaPdf = async (id, { shipFrom } = {}) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/${id}/docs/factura`,
    {
      headers: authHeaders(),
      responseType: "blob",
      params: {
        ...(shipFrom ? { shipFrom } : {}),
      },
    },
  );
  const filename = filenameFromContentDisposition(
    response.headers?.["content-disposition"],
    `CustomInvoice_${id}.pdf`,
  );
  downloadBlobAsFile(response.data, filename);
  return filename;
};

/** Crea el envío real en MyDHL y guarda el AWB. */
export const createCourierDhlShipment = async (id, { shipFrom } = {}) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/${id}/dhl/shipment`,
    { ...(shipFrom ? { shipFrom } : {}) },
    { headers: authHeaders() },
  );
  return response.data;
};

/** Pide a DHL que anule un envío que todavía no ha recogido. */
export const cancelCourierDhlShipment = async (id, { reason } = {}) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/${id}/dhl/cancel`,
    { reason },
    { headers: authHeaders() },
  );
  return response.data;
};

/** Tracking Pull del AWB. */
export const fetchCourierDhlTracking = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/${id}/dhl/tracking`,
    { headers: authHeaders() },
  );
  return response.data;
};

/** Descarga la etiqueta DHL (caché o get-image). */
export const downloadCourierDhlLabel = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/${id}/dhl/label`,
    {
      headers: authHeaders(),
      responseType: "blob",
    },
  );
  const filename = filenameFromContentDisposition(
    response.headers?.["content-disposition"],
    `DHL_${id}.pdf`,
  );
  downloadBlobAsFile(response.data, filename);
  return filename;
};
